import * as React from 'react';
import type { IllustrationT } from '../types';
import { SquigglyArrowIllustration1 } from './SquigglyArrowIllustration1';
import { SquigglyArrowIllustration2 } from './SquigglyArrowIllustration2';
import { SquigglyArrowIllustration3 } from './SquigglyArrowIllustration3';
import { SquigglyArrowIllustration4 } from './SquigglyArrowIllustration4';
import { SquigglyArrowIllustration5 } from './SquigglyArrowIllustration5';
import { SquigglyArrowIllustration6 } from './SquigglyArrowIllustration6';
import { SquigglyArrowIllustration7 } from './SquigglyArrowIllustration7';
import { SquigglyArrowIllustration8 } from './SquigglyArrowIllustration8';

export type SquigglyArrowVariant =
  | 'SquigglyArrowIllustration1'
  | 'SquigglyArrowIllustration2'
  | 'SquigglyArrowIllustration3'
  | 'SquigglyArrowIllustration4'
  | 'SquigglyArrowIllustration5'
  | 'SquigglyArrowIllustration6'
  | 'SquigglyArrowIllustration7'
  | 'SquigglyArrowIllustration8';

export interface ModularIllustrationWrapperProps extends IllustrationT {
  /**
   * The variant of the SquigglyArrow illustration to render
   */
  variant: SquigglyArrowVariant;
  /**
   * Rotation in degrees (e.g., 210, -45, 90)
   */
  rotation?: number;
  /**
   * Height in pixels
   */
  height?: number;
}

const illustrationComponents = {
  SquigglyArrowIllustration1,
  SquigglyArrowIllustration2,
  SquigglyArrowIllustration3,
  SquigglyArrowIllustration4,
  SquigglyArrowIllustration5,
  SquigglyArrowIllustration6,
  SquigglyArrowIllustration7,
  SquigglyArrowIllustration8,
} as const;

export const ModularIllustrationWrapper: React.FC<
  ModularIllustrationWrapperProps
> = ({
  variant,
  rotation,
  height = 50,
  color,
  userColor,
  'aria-hidden': ariaHidden,
  'aria-label': ariaLabel,
}) => {
  const IllustrationComponent = illustrationComponents[variant];

  const style = React.useMemo(() => {
    const styleObj: React.CSSProperties = {};

    if (rotation !== undefined) {
      styleObj.transform = `rotate(${rotation}deg)`;
    }

    if (height !== undefined) {
      styleObj.height = `${height}px`;
    }

    return Object.keys(styleObj).length > 0 ? styleObj : undefined;
  }, [rotation, height]);

  return (
    <div style={style}>
      <IllustrationComponent
        color={color}
        userColor={userColor}
        aria-hidden={ariaHidden}
        aria-label={ariaLabel}
      />
    </div>
  );
};
